import { InviteSharedChannelParam } from '@@types/Api/Member';
import { CHANNEL_ID, TENANT_ID } from '@@types/common';
import { SharedChannelMember } from '@@types/Member';

import { URLS } from '~/constants';
import InterTenantApi from '~/stores/providers/InterTenantApi';
import { curry } from 'ramda';

class SharedChannelMemberApi {
  inviteSharedChannelMember = curry((channelId: CHANNEL_ID, param: InviteSharedChannelParam[]): Promise<'OK'> => {
    return this.api.resultRequester.post(`${URLS.V4_API}/channels/${channelId}/send-invitation`, param);
  });

  constructor(private api: InterTenantApi) {}

  fetchChannelMembers = (tenantId: TENANT_ID, channelId: CHANNEL_ID): Promise<SharedChannelMember[]> => {
    return this.api.resultRequester.cancelPost(
      `${URLS.V4_API}/channels/${channelId}/members/fetch?excludeTenants=${tenantId}`,
      {},
      channelId
    );
  };
}

export default SharedChannelMemberApi;
